import styled from 'styled-components';
import Colors from '../../../config/Colors';
import { Button } from '../../../components-reactjs/Button';

export const FreteContentContainer = styled.div`
    display: flex;
    flex: 1;
    flex-grow: 1;
    flex-direction: column;
`;

export const ScrollConfig = styled.div`
    padding: 0 0 0 25px;
    flex-direction: column;
    display: flex;
    width: 100%;
`;

export const Form = styled.form`
    margin-top: 15px;
`;

export const FormAddItem = styled.form`
    display: flex;
    justify-content: space-between;
`;

export const FixedPriceContainer = styled.div`
    padding-left: 30px;
    width: fit-content;
`;

export const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    ${({ marginR }) => {
        return marginR && `margin-right: ${marginR}px`;
    }}
`;

export const ListItemsContainer = styled.div`
    padding-left: 30px;
    width: 250px;
`;

export const ButtonsRow = styled.div`
    display: flex;
    margin: 15px 0 25px 0;
`;

export const Descricao = styled.label`
    color: ${Colors.black};
    font-family: NunitoSans-Regular;
    font-size: 1.4rem;
    margin-bottom: 3px;
    margin-left: 0;
    opacity: 0.8;
`;

export const FreteModalContainer = styled.div`
    min-height: 300px;
    min-width: 380px;
    display: flex;
    flex-direction: column;
    font-family: NunitoSans-Bold;
    font-size: 1.8rem;
`;

export const ModalHeader = styled.header`
    padding: 24px;
    border-bottom: 1px solid ${Colors.border};
`;

export const ModalHeaderTitle = styled.h1`
    font-family: NunitoSans-Bold;
    font-size: 1.8rem;
    align-self: flex-start;
    margin-bottom: 5px;
    opacity: 0.8;
`;

export const ModalContent = styled.div`
    display: flex;
    flex: 7;
    justify-content: space-between;
    align-items: center;
    padding: 0 25px 0 25px;
    position: relative;
`;

export const ModalRow = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const ModalFooter = styled.footer`
    border-top: 1px solid ${Colors.border};
    padding-right: 25px;
    display: flex;
    flex: 3;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`;

export const SaveButton = styled(Button)`
    margin-right: 15px;
    font-size: 1.4rem;
    min-height: 35px;
    min-width: fit-content;
    width: 80px;
    height: 40px;
`;

export const CancelButton = styled(Button)`
    font-size: 1.4rem;
    background-color: ${Colors.grey_light};
    color: ${Colors.dark};
    border: 1px solid ${Colors.regular};
    min-height: 35px;
    min-width: fit-content;
    width: 80px;
    height: 40px;
`;
